/* eslint-disable no-undefined */
import React from "react";
import PropTypes from "prop-types";
import { endOfDay, startOfDay } from "date-fns";
//Date Picker
import { Calendar } from "react-date-range";
import enGb from "react-date-range/dist/locale/en-GB";
const SingleDatePicker = ({
  classes,
  onChange,
  selectionRange,
  minDate,
  maxDate,
  infiniteEndDate
}) => {
  const handleSelect = selectedDate => {
    //maps the single value onto a range
    const selection = {
      startDate: startOfDay(selectedDate),
      endDate: endOfDay(selectedDate)
    };
    onChange(selection);
  };
  const value = selectionRange.startDate;
  return /*#__PURE__*/React.createElement(Calendar, {
    className: classes.dateRangePickerContainer,
    date: value,
    color: "#3372FF",
    onChange: handleSelect,
    minDate: minDate,
    maxDate: infiniteEndDate ? undefined : maxDate,
    inputRanges: [],
    locale: enGb,
    disablePassive: true
  });
};
export default SingleDatePicker;
SingleDatePicker.propTypes = {
  classes: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  selectionRange: PropTypes.object,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  infiniteEndDate: PropTypes.bool
};